import { defineMessages } from "react-intl";

const messages = defineMessages({
    start: {
        id: "subscore.sync.start",
    },
    redo: {
        id: "subscore.sync.redo",
    },
    completed: {
        id: "subscore.sync.completed",
    },
    tutorial: {
        id: "subscore.sync.tutorial",
    },
});

export default messages;
